/**
 * Multivariate Experiment Configuration
 * Maps experiment keys to cookie prefixes and WebEngage event attribute keys.
 */

export interface ExperimentDefinition {
  prefix: string;
  eventAttributeKey: string;
}

export const MULTIVARIATE_EXPERIMENT_CONFIG = {
  HOME: {
    prefix: 'EX_HOME_',
    eventAttributeKey: 'Home Page Variant',
  },
  // GOLD_COIN_PLP: {
  //   prefix: 'EX_GOLDCOINPLP_',
  //   eventAttributeKey: 'Gold Coin Page Variant',
  // },
  PLP: {
    prefix: 'EX_PLP_',
    eventAttributeKey: 'PLP Page Variant',
  },
  PDP: {
    prefix: 'EX_PDP_',
    eventAttributeKey: 'PDP Page Variant',
  },
  GUEST_CHECKOUT: {
    prefix: 'EX_GC_',
    eventAttributeKey: 'Guest Checkout Variant',
  },
} as const;

export type ExperimentType = keyof typeof MULTIVARIATE_EXPERIMENT_CONFIG;
